import React, { memo } from "react";
import useLanguageMenu from "./index.hooks";
import {
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
} from "@material-ui/core";
import { LanguageValues } from "models/Language";
import { Language } from "models";

type LanguageMenuProps = {};

const LanguageMenu = ({}: LanguageMenuProps) => {
  const {
    styles,
    classes,
    anchorOrigin,
    transformOrigin,
    atomicStyles,
    anchorRef,
    isLanguageSelectorMenuOpen,
    handleLanguageSelectorMenuOpen,
    handleLanguageSelectorMenuClose,
    handleListItemClick,
    currentUserLanguage,
  } = useLanguageMenu();

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleLanguageSelectorMenuOpen}
        className={styles.menuIcon}
        size="medium"
      >
        <img
          src={Language.getFlagIconByLanguageValue(currentUserLanguage)}
          alt={Language.getLanguageNameByLanguageValue(currentUserLanguage)}
          className={styles.flag}
        />
      </IconButton>
      <Menu
        id="menu-language"
        anchorEl={anchorRef.current}
        getContentAnchorEl={null}
        open={isLanguageSelectorMenuOpen}
        onClose={handleLanguageSelectorMenuClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        classes={classes.popoverPaper}
      >
        <List disablePadding>
          {Object.keys(LanguageValues).map((languageKey, index) => (
            <ListItem
              button
              key={languageKey}
              selected={currentUserLanguage === LanguageValues[languageKey]}
              onClick={handleListItemClick[index]}
              className={styles.menuItem}
            >
              <ListItemIcon className={styles.flagContainer}>
                <img
                  src={Language.getFlagIconByLanguageValue(
                    LanguageValues[languageKey],
                  )}
                  alt={Language.getLanguageNameByLanguageValue(
                    LanguageValues[languageKey],
                  )}
                  className={styles.flag}
                />
              </ListItemIcon>
              <ListItemText>
                {Language.getLanguageNameByLanguageValue(
                  LanguageValues[languageKey],
                )}
              </ListItemText>
            </ListItem>
          ))}
        </List>
      </Menu>
    </>
  );
};

export default memo(LanguageMenu);
